import { gql } from "@apollo/client";

export default gql`
  query listAiMessageSteps($aiMessageId: ID!, $answerId: ID){
    listAiMessageSteps(aiMessageId: $aiMessageId, answerId: $answerId){
        success
        data{
            _id
            aiMessageId
            step
            stepList
            status
            durationMs
            summary
            reason
            request
            response
            source
            createdAt
            updatedAt
        }
        code
        message
    }
}
`
